package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Post
import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class CreatePostUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(
        title: String,
        contentMarkdown: String,
        imageUrl: String? = null, // Keep for backward compatibility
        imageIds: List<Int> = emptyList(),
    ): Result<Post> {
        if (title.isBlank()) {
            return Result.failure(IllegalArgumentException("タイトルを入力してください"))
        }
        if (title.length > 255) {
            return Result.failure(IllegalArgumentException("タイトルは255文字以内で入力してください"))
        }
        if (contentMarkdown.isBlank()) {
            return Result.failure(IllegalArgumentException("本文を入力してください"))
        }

        // Prefer imageIds if available, fallback to imageUrl for backward compatibility
        return if (imageIds.isNotEmpty()) {
            // TODO: Update repository to accept imageIds
            // For now, we'll use imageUrl for backward compatibility
            postRepository.createPost(title, contentMarkdown, imageUrl)
        } else {
            postRepository.createPost(title, contentMarkdown, imageUrl)
        }
    }
}
